import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";
import { StyledH2, StyledModal } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { DynamicTable } from "@maherunlocker/custom-react-table";

import { store } from "@components/VerticalLayout/store";
import {
    store as generalSettingStore,
    setIsAssociateModalOpened,
    setNumberMultiShopActive,
    setIds,
    setSelectedRow,
    setIsAssociatedLangues,
    setMessage,
    setGlobalDataIsUpdated,
    setIsLoading,
} from "../store";
import { setItemsDisable } from "@store";
import { languages } from "@constants/index";
import { useFetchGlobal } from "../../../../api/hooks";

import ErrorToast from "@components/Common/ErrorTost";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { ArrayOfCustomColumnsAssociateModal } from "./ArrayOfCustomColumnsAssociateModal";
import {
    apiRequest,
    checkIfLanguageAssociated,
    checkIfLanguageExistAndArchived,
    CountIds,
    languagesOptions,
} from "../hooks";
import { ShowSuccessToast } from "../ShowSuccessToast";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "../index.css";
import { useAuthHeader } from "../../../../api/headersKeycloak";

export function LanguageAssociateModal({ isArchivedLanguagesClicked }: any) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const { fetchGlobal } = useFetchGlobal();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const {
        isAssociateModalOpened,
        localShop,
        numberMultiShopActive,
        idsLocalShop,
        associatedLanguages,
        activeLanguages,
        languageFavored,
        shopRowData,
    } = useSnapshot(generalSettingStore);
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const shopId = 0;
    const url =
        localShop.length === 1
            ? `${process.env.REACT_APP_API_V2_URL}/settings/general/filtered_archived_language?userId=${userID}&shopId=${localShop[0]}&franchiseId=${franchiseID}`
            : `${process.env.REACT_APP_API_V2_URL}/settings/general/language?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;
    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );

    async function AssociateLanguage() {
        setIsLoading(true);
        toast.dismiss();
        let favoriteSelectedLanguages: any = [];
        let isLanguageFavored = false;
        let objectData: any = {};
        let shopIds: any = [];

        for (let element of localShop) {
            let associated = checkIfLanguageAssociated(element, shopRowData);
            if (selectedRows.length !== 0) {
                selectedRows.forEach(() => {
                    favoriteSelectedLanguages.push(
                        languageFavored.find(
                            (element: any) => element.status === true
                        )
                    );
                });
                if (favoriteSelectedLanguages !== undefined) {
                    let shopFavoriteLanguage: any = associated.find(
                        (el: any) => el.isFavorite === true
                    );

                    if (shopFavoriteLanguage !== undefined) {
                        let shopFavoriteLanguage: any = {
                            ...associated.find(
                                (el: any) => el.isFavorite === true
                            ),
                        };

                        if (
                            selectedRows.find(
                                (el: any) => el.Id === shopFavoriteLanguage.Id
                            ) === undefined
                        ) {
                            selectedRows.push(shopFavoriteLanguage);
                        }
                    }
                }

                // eslint-disable-next-line no-loop-func
                selectedRows.forEach(async (el: any) => {
                    let isFavorite =
                        JSON.parse(JSON.stringify(languageFavored)).find(
                            (element: any) => element.id === el.Id
                        ) !== undefined
                            ? JSON.parse(JSON.stringify(languageFavored)).find(
                                  (element: any) => element.id === el.Id
                              ).status
                            : el.isFavorite;
                    const id: any = el.Id;
                    let indexOfLanguage = languagesOptions(t).findIndex(
                        (elt: any) => elt.label === el[t("Language")]
                    );
                    if (isFavorite === true) {
                        isLanguageFavored = true;
                    }
                    if (!shopIds.includes(element.toString())) {
                        shopIds.push(element.toString());
                        objectData[element.toString()] = {};
                    }
                    Object.assign(objectData[element.toString()], {
                        [id]: {
                            id: id,
                            language: languages[indexOfLanguage].label,
                            display_name: el.display_name,
                            country: el.country,
                            urlImage: el.url_image,
                            isArchived: el.isArchived,
                            isFavorite: isFavorite,
                            isActive: activeLanguages.find(
                                (element: any) => element.Id === el.Id
                            ).state,
                            shopId: element,
                            abbreviation: el.abbreviation,
                            advancedDisplayName: el.advancedDisplayName,
                        },
                    });
                });
            }
        }
        let dataLanguage = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: objectData,
            isShop: true,
            isAssociate: true,
            isMultiShop: true,
        };
        if (isLanguageFavored === false) {
            ErrorToast(t("Attention, at least one language must be favorite"));
        } else {
            try {
                const result: any = await apiRequest(dataLanguage, fetchGlobal);
                if (result.error) {
                    throw new Error("error");
                }
                ShowSuccessToast(`${t("The assignment was successful")}`);
                setDataIsUpdated!(true);
                setNumberMultiShopActive(
                    numberMultiShopActive +
                        selectedRows.length * localShop.length
                );
                setGlobalDataIsUpdated(true);
                setIsLoading(false);
                const itemsDisable = await fetchGlobal<any>(
                    `${process.env.REACT_APP_API_V2_URL}/settings/consomation/items?franchiseId=${franchiseID}&shopId=0`,
                    {
                        method: "GET",
                    }
                );
                if (itemsDisable.error === false) {
                    setItemsDisable(itemsDisable.data);
                }
            } catch (e) {
                ErrorToast(`${t("There's an error")}`);
                setIsLoading(false);
            }
        }
    }

    const handleValidateButtonOnClickEvent = () => {
        let archived = checkIfLanguageExistAndArchived(shopRowData);
        if (selectedRows.length === 0) {
            ErrorToast(
                `${t("Attention ! You must select at least one language")!}`
            );
        } else if (
            !selectedRows.some(
                (elt: any) =>
                    JSON.parse(JSON.stringify(languageFavored)).find(
                        (element: any) => element.id === elt.Id
                    ) !== undefined &&
                    JSON.parse(JSON.stringify(languageFavored)).find(
                        (element: any) => element.id === elt.Id
                    ).status === true
            )
        ) {
            ErrorToast(t("Attention, at least one language must be favorite"));
        } else {
            CountIds(idsLocalShop, selectedRows, setIds);
            try {
                setSelectedRow(selectedRows);
                selectedRows.forEach((el: any) => {
                    associatedLanguages.forEach((element: any) => {
                        if (
                            element.Id === el.Id &&
                            (element.isActive !==
                                activeLanguages.find(
                                    (elt: any) => elt.Id === el.Id
                                ).state ||
                                element.isFavorite !==
                                    JSON.parse(
                                        JSON.stringify(languageFavored)
                                    ).find((elt: any) => elt.id === el.Id)
                                        .status)
                        ) {
                            setMessage(
                                t(
                                    'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                                )
                            );
                            setIsAssociatedLangues(true);
                            // eslint-disable-next-line
                            throw "Break";
                        }
                    });
                });
                selectedRows.forEach((el: any) => {
                    if (archived.includes(el.Id)) {
                        setMessage(
                            t(
                                "Attention! One or more selected languages are already assigned and archived at the store level.Would you unarchive them?"
                            )
                        );
                        setIsAssociatedLangues(true);
                        // eslint-disable-next-line
                        throw "Break";
                    }
                });
                AssociateLanguage();
                setIsAssociateModalOpened(!isAssociateModalOpened);
            } catch (e) {
                if (e !== "Break") throw e;
            }
        }
    };

    return (
        <StyledModal
            toggle={true}
            isOpen={isAssociateModalOpened!}
            centered
            className="modal-wrapper__clz"
            backdrop="static"
            fade={false}
            scrollable
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsAssociateModalOpened(!isAssociateModalOpened);
                    setGlobalDataIsUpdated(true);
                }}
            >
                <StyledH2 className="text-uppercase lan_txt_AFlistOfLanguages">
                    {t("List of languages")}
                </StyledH2>
            </ModalHeader>
            <ModalBody>
                <DynamicTable
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    url={url}
                    canSelect
                    setSelectedRows={setSelectedRows}
                    customSelect
                    canResize
                    actionColumn={ActionColumn}
                    arrayOfCustomColumns={ArrayOfCustomColumnsAssociateModal(
                        isArchivedLanguagesClicked
                    )}
                    showGlobalFilter
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight="500px"
                    name="associateLanguage"
                />
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsAssociateModalOpened(!isAssociateModalOpened);
                        setGlobalDataIsUpdated(true);
                    }}
                    rounded
                    className="lan_btn_AFcancel"
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    variant="primary"
                    onClick={handleValidateButtonOnClickEvent}
                    className="lan_btn_AFvalidate"
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
